export const textDoesNotContainSpecialCharactersRegEx = new RegExp('^[a-zA-ZÀ-ž\\d ]+$');
